import { SubscriptionCancelledNotification } from './SubscriptionCancelledNotification';
import { SubscriptionSuspendedNotification } from './SubscriptionSuspendedNotification';
import { SubscriptionGraceNotification } from './SubscriptionGraceNotification';
import { useSubscriptionStatus } from '@/bundle/shared/hooks/useSubscriptionStatus';

type SubscriptionNotificationsType = {
  subscriptionExpirationDate: string;
  isLoading: boolean;
  onRetryPayment: () => void;
  onReactiveSubscription: () => void;
  onCustomerPortalNavigate: () => void;
};

export const SubscriptionNotifications = ({
  subscriptionExpirationDate,
  isLoading,
  onRetryPayment,
  onReactiveSubscription,
  onCustomerPortalNavigate,
}: SubscriptionNotificationsType) => {
  const { isGraceSubscription, isSuspendedSubscription, isCancelledSubscription } = useSubscriptionStatus();

  return (
    <>
      {isGraceSubscription && (
        <SubscriptionGraceNotification
          onRetryPayment={onRetryPayment}
          onCustomerPortalNavigate={onCustomerPortalNavigate}
          subscriptionExpirationDate={subscriptionExpirationDate}
          isLoading={isLoading}
        />
      )}

      {isSuspendedSubscription && (
        <SubscriptionSuspendedNotification
          onRetryPayment={onRetryPayment}
          onCustomerPortalNavigate={onCustomerPortalNavigate}
          isLoading={isLoading}
        />
      )}

      {isCancelledSubscription && (
        <SubscriptionCancelledNotification onReactiveSubscription={onReactiveSubscription} isLoading={isLoading} />
      )}
    </>
  );
};
